(function($){
    var overlay         = $('.overlay'),
        $header          = $('.header'),
        matchHeight    = $('.match_height'),
        $window         = $(window);

    //    Header background
    if ( $(window).scrollTop() > 10 ) {
        $header.addClass('white');
        $('.contact_page').addClass('top');
    }else{
        $header.removeClass('white');
        $('.contact_page').removeClass('top');
    }

    $(window).on('scroll resize', function(){
        if ( $(window).scrollTop() > 10 ) {
            $('.header').addClass('white');
            $('.contact_page').addClass('top');
        }else{
            $('.header').removeClass('white');
            $('.contact_page').removeClass('top');
        }
    });


    if( matchHeight.length > 0){
        matchHeight.matchHeight();
        $window.on('resize', function(){
            matchHeight.matchHeight();
        });
    }

    var arrowDown = "<i class='mgi-chevron-down'></i>";
    var hasChildren = $('.menu-item-has-children');
    hasChildren.append(arrowDown);
    var triggerSubmenu = hasChildren.find('.mgi-chevron-down');
    if( $window.width() < 768 ){
        triggerSubmenu.css('display', 'block');
        triggerSubmenu.on('click', function(){
            $(this).toggleClass('mgi-chevron-up');
            $(this).prev().toggleClass('on');
        });
    }else{
        triggerSubmenu.css('display', 'none');
    }

    $window.on('resize', function(){
        if($window.width() < 768 ){
            triggerSubmenu.css('display', 'block');
        }else{
            triggerSubmenu.css('display', 'none');
            $header.removeClass('mobile_menu');
        }
    });

    $('.navbar-toggle').on('click', function(){
        $header.toggleClass('mobile_menu');
    });

    $('.gfield_checkbox').find('label').prepend('<span>');
    $('.gfield_checkbox').find('label').append('</span>');

    $('.banner_intro button').on('click', function(){
        localStorage.setItem("formId", $(this).attr('data-target'));
    });

    if ( $('.validation_error').length > 0 ){
        formToReopen = localStorage.getItem("formId");
        $(formToReopen).modal();
    }

    var searchTrigger = $('nav .mgi-search');

    searchTrigger.on('click', function(){
        $(this).toggleClass('current-menu-item');
        $('.search_field').toggleClass('show');
    });

    var region = $('.mgi_region'),
        location = $('.mgi_location'),
        goToWebsite = $('.find_advisor_button');

    region.on('change', function(){
        location.find('option').css('display', 'none');
        location.find('.' + $(this).val()).css('display', 'block');
    });

    goToWebsite.on('click', function(){
        window.open (location.val(),'_blank');
    });

    var youtubePopup = $('.youtube_popup');
    youtubePopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="https://www.youtube.com/embed/'+video+'?autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var vimeoPopup = $('.vimeo_popup');
    vimeoPopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="https://player.vimeo.com/video/'+video+'?color=ffffff&portrait=0&autoplay=true" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var videoPopup = $('.video_popup');
    videoPopup.on('click', function(e){
        e.preventDefault();
        var video = $(this).attr('data-video');
        var iframe = '<iframe src="'+video+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        $('#video_modal .video').html(iframe);
        $('#video_modal').modal('show');
    });

    var videoPopup = $('.survey-popup');
    videoPopup.on('click', function(e){
        e.preventDefault();
        $('#my_survey_modal').modal('show');
    });

	// Plyr.io //
	if($('.page-template-template-landing-page-php iframe').length > 0) {
		$('.page-template-template-landing-page-php iframe').each(function(){
			var source = $(this).attr('src');
			var video_type  = source.match("^(http[s]?:\\/\\/(www\\.)?){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");

			if (video_type) {
				if (video_type[3] && video_type[3] == "youtube") {
					$(this).replaceWith('<div class="js-player" data-type="youtube" data-video-id="' + source + '"></div>');
					setTimeout(function () {
						plyr.setup('.js-player');
					}, 100);
				}
				else if (video_type[3] && video_type[3] == "player.vimeo") {
					$(this).replaceWith('<div class="js-player" data-type="vimeo" data-video-id="' + source + '"></div>');
					setTimeout(function () {
						plyr.setup('.js-player');
					}, 100);
				}
			}
		});
	}

    var stats1 = $('.stats_1');
    var stats2 = $('.stats_2');
    var stats3 = $('.stats_3');
    var stats4 = $('.stats_4');
    var stats5 = $('.stats_5');
    var stats6 = $('.stats_6');
    var stats7 = $('.stats_7');
    var stats8 = $('.stats_8');
    var visible = $('.stats_visible');


    function loopStats() {
        var randomFade = function(statsIn, statsOut, time){
            if (statsIn.length && statsOut.length){
                setTimeout(function(){
                    if( statsIn.find(visible) ){
                        statsIn.removeClass('stats_visible');
                        statsOut.addClass('stats_visible');
                    }
                },time);
            }
        };
        
        randomFade(stats1, stats5, 2000);
        randomFade(stats2, stats6, 4000);
        randomFade(stats3, stats7, 6000);
        randomFade(stats4, stats8, 8000);
        randomFade(stats5, stats1, 10000);
        randomFade(stats6, stats2, 12000);
        randomFade(stats7, stats3, 14000);
        randomFade(stats8, stats4, 16000);

        window.setTimeout(function() { loopStats() }, 18000)
    }

    loopStats();

    function msieDetect() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        {
            $('body').addClass('ie')
        }
        return false;
    }
    msieDetect();

})(jQuery);